import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('webhook/([a-zA-Z]+)', form);
Router.get('webhook', index);
